




import { Component, Vue } from 'vue-property-decorator';
import store from '@/store';

import ServiceGuideDetails from '@/components/guide/ServiceGuideDetails.vue';
import { removeLoader } from '@/utils';

@Component({
  components: {
    ServiceGuideDetails
  }
})
export default class ServiceGuideDetailsView extends Vue {
  tabIndex = 0;

  created() {
    removeLoader();
  }

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.tabIndex = +to.params.id <= 3 ? +to.params.id : 0;
    });
  }

  beforeRouteUpdate(to, from, next) {
    this.tabIndex = Number(to.params.id);
    next();
  }
}
